export const TEAM_JERSEY_LINKS: {
  [key: string]: {
    jerseyImage: string
    jerseyLink: string
  }
} = {
  archers: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/24-Regular-Home-Archers-AME-YM_1_f3bf4f39-5b48-43e0-a745-bee374fa13d4.png?v=1732141217&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/utah-archers-player-replica-jerseys',
  },
  atlas: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U966TU-Atlas-Front_Home_dabf568a-a7f6-4a36-b306-84e434fae438.png?v=1716484010&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/new-york-atlas-player-replica-jerseys',
  },
  cannons: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U966TU-Cannons-Front_Home_2385eb12-8ed6-48be-9dd9-f973202b418c.png?v=1716910336&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/boston-cannons-player-replica-jerseys',
  },
  chaos: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U964TU-Chaos-Front_HomeYouth.png?v=1716483863&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/carolina-chaos-player-replica-jerseys',
  },
  outlaws: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U964TU-Outlaws-Front_HomePlayer24_e5b1f3a2-991e-4f74-b301-73831a6e4cae.png?v=1716483949&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/denver-outlaws-player-replica-jerseys',
  },
  redwoods: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U966TU-Redwoods-Front_Away.png?v=1716225850&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/california-redwoods-player-replica-jerseys',
  },
  whipsnakes: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/24-Regular-Away-Whipsnakes-RAM-AL_1_601bea0a-8cf6-4e9c-b05d-b26f4ff42dc0.png?v=1732143378&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/maryland-whipsnakes-player-replica-jerseys',
  },
  waterdogs: {
    jerseyImage:
      'https://shop.premierlacrosseleague.com/cdn/shop/files/U964TU-Waterdogs-Front_Home_7e21e209-c65f-4b28-b31b-b18eb097e54f.png?v=1716912181&width=500',
    jerseyLink: 'https://shop.premierlacrosseleague.com/collections/philadelphia-waterdogs-player-replica-jerseys',
  },
}
